import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { LibraryCourseContainerStore } from './typings';

const initialState: LibraryCourseContainerStore = {
    openedModule: null,
    expandedLessonGroup: null,
    openedCourseContainerSlug: null,
};

const slice = createSlice({
    name: 'LIBRARY_COURSE_CONTAINER',
    initialState: initialState,
    reducers: {
        setOpenedModuleId: (state: LibraryCourseContainerStore, action: PayloadAction<{ moduleId: number | null }>) => {
            state.openedModule = action.payload.moduleId;
        },
        setOpenedCourseContainerSlug: (
            state: LibraryCourseContainerStore,
            action: PayloadAction<{ slug: string | null }>
        ) => {
            state.openedCourseContainerSlug = action.payload.slug;
        },
        setExpandedLessonGroupId: (
            state: LibraryCourseContainerStore,
            action: PayloadAction<{ lessonGroupId: string | null }>
        ) => {
            state.expandedLessonGroup = action.payload.lessonGroupId;
        },
    },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
